export default __webpack_public_path__ + "static/media/transit-bus.277f0414.jpg";